import React, { Component } from 'react';
import Product from './Product';

class Products extends Component {
	render() {
		var page     = this.props.page;
		var perPage  = this.props.perPage;
		var products = this.props.products;
		var offset   = (page - 1) * perPage;
		var items    = products.slice(offset, (offset + perPage));

		return (
			<div className="grid grid--products">

				{items.map((product, index) =>
					<div key={product.id} className="grid__item" itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
							<meta content="{index}" itemProp="position" />
						<Product name={product.name} summary={product.summary} url={product.url} image={product.image} mod={this.props.mod} />

					</div>
				)}

			</div>
		);
	}
}

export default Products;
